import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Text } from 'pcln-design-system'
import {
  FlexDatesCollapsibleContainer,
  FlexDatesCarousel,
} from '@pcln/flex-dates'
import {
  getFormattedFlexDates,
  getSortedPrices,
  getFlexDatesTrackingPayload,
} from './helpers'
import { logViewItemListFlexDates } from '../../../../common/log-ga-event/logGaEvent-view-item-list'
import {
  logSelectItemCollapseFlexDates,
  logSelectItemFlexDate,
} from '../../../../common/log-ga-event/logGaEvent-select-item'

const FlexDatesCollapsableOw = ({ flexDates, searchDestination }) => {
  const sortedPrices = getSortedPrices(flexDates)
  const minPrice = sortedPrices[0]
  const maxPrice = sortedPrices[sortedPrices.length - 1]

  const onSlideClick = (index, e) => {
    const { isOriginalDepartDate, flexDateSearchUrl } = flexDates[index]
    if (!isOriginalDepartDate && flexDateSearchUrl) {
      e.preventDefault()
      window.open(flexDateSearchUrl, '_blank')
    }
    logSelectItemFlexDate(
      getFlexDatesTrackingPayload({
        flexDates,
        minPrice,
        maxPrice,
        searchDestination,
        selectedIndex: index,
      })
    )
  }

  useEffect(() => {
    const trackingPayload = getFlexDatesTrackingPayload({
      flexDates,
      minPrice,
      maxPrice,
      searchDestination,
    })
    logViewItemListFlexDates(trackingPayload)
  }, [])

  return (
    <Box maxWidth='810px' mb={3} mx={[2, 2, 2, 2, 0]}>
      <FlexDatesCollapsibleContainer
        title='Flexible dates?'
        subTitle='Compare prices and save'
        isOpen
        onClose={() => logSelectItemCollapseFlexDates()}
      >
        <Box pb={2}>
          <FlexDatesCarousel
            flexDates={getFormattedFlexDates(flexDates, sortedPrices)}
            onSlideClick={onSlideClick}
          />
          {sortedPrices.length > 1 ? (
            <Flex mt='12px' px={3}>
              <Text fontSize={0} mr={2}>
                Avg. price
              </Text>
              <Box color='highlight.light' px={1} borderRadius='full' mr={1}>
                <Text fontSize={0}>${sortedPrices[0]}</Text>
              </Box>
              <Box color='notify.light' px={1} borderRadius='full' mr={1}>
                <Text fontSize={0}>${sortedPrices[1]}+</Text>
              </Box>
              {sortedPrices.length > 2 ? (
                <Box color='warning.light' px={1} borderRadius='full' mr={1}>
                  <Text fontSize={0}>
                    ${sortedPrices[sortedPrices.length - 1]}
                  </Text>
                </Box>
              ) : null}
            </Flex>
          ) : null}
        </Box>
      </FlexDatesCollapsibleContainer>
    </Box>
  )
}

FlexDatesCollapsableOw.propTypes = {
  flexDates: PropTypes.array,
  searchDestination: PropTypes.string,
}

export { FlexDatesCollapsableOw }
